// extracted by mini-css-extract-plugin
export default {"head":"u915yqnlmJrTUTivPtij","customList":"OTYywqHWoWzo5067aLXq","ballContainer":"tUqRqFOpaJDOSitl253Z"};